import { SafeUrl } from '@angular/platform-browser';

export default class Asset {
  uuid?: string;
  name: string;
  type: string;
  size: number;
  base64: string;

  // offline storage variables
  localFileUuid?: string;
  localFile?: File;
  localSafeUrl?: SafeUrl;
}
